import { Controller } from "@hotwired/stimulus"

// 選んだファイル名を出す。選択後に何も変わらないと、選べたのか分からない。
export default class extends Controller {
  static targets = ["label"]
  declare readonly labelTarget: HTMLElement

  show(event: Event) {
    const input = event.target as HTMLInputElement
    const file = input.files?.[0]
    this.labelTarget.textContent = file ? file.name : "選択されていません"
  }
}
